import axios, { AxiosRequestConfig } from 'axios';
import {environment} from '../environment/environment'
import { SessionData, TokenPayload } from '../models/IToken';
import TokenService from './token.service';
import { getDataFromLocalStorage } from './storage.service';


const RelativePaths = {
  Uploads: 'uploads',
  UploadComplete: 'complete',
  Storage: 'storage'

};

const chunkSize = 512 * 1024; // 512 KB

interface UploadResponse {
  uploadId: string;
}
interface sessionUser {
  name: string;
  mail: string;
}

class FileUploadService {
  private async initUploadAsync(uploadUrl: string, file: File,): Promise<any> {
    const formData = new FormData();
    formData.append('fileName', file.name);

    const response = await axios.post<UploadResponse>(uploadUrl, {fileName: file.name}, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  }

  sessionId: string = '';
  sessionUserInfo: sessionUser = {name: '', mail: ''};

  private getParticipantipantInfo(){
    let parsedToken: TokenPayload = TokenService.parseToken(true, "");
    let participantDetail: SessionData = JSON.parse(parsedToken.metadata);
    this.sessionUserInfo.name = participantDetail.pName;
    this.sessionUserInfo.mail = participantDetail.pEmail;
    this.sessionId = parsedToken.video.room;
    
  }

  private async sendFileAsync(url: string, file: File): Promise<void> {
    let position = 0;

    do {
      const buffer = await file.slice(position, position + chunkSize).arrayBuffer();
      const config: AxiosRequestConfig = {
        headers: {
          'Content-Type': 'application/octet-stream',
          'offset': position.toString(),
        },
      };

      await axios.post(url, buffer, config);
      position += buffer.byteLength;
    } while (position < file.size);
  }

  public async uploadAsync(file: File): Promise<any> {

    const fetchedConfig = getDataFromLocalStorage('staticConfig');
    const uploadUrl = `${fetchedConfig.contentService}/${RelativePaths.Storage}/${RelativePaths.Uploads}`;
    const fileInfo = await this.initUploadAsync(uploadUrl, file);
    const chunkUploadUrl = `${uploadUrl}/${fileInfo.id}?size=${file.size}&path=${encodeURIComponent(fileInfo.path)}`;

    await this.sendFileAsync(chunkUploadUrl, file);

    const uploadCompleteUrl = `${uploadUrl}/${fileInfo.id}/${RelativePaths.UploadComplete}`;
    this.getParticipantipantInfo();
    const signedUrl = await axios.patch(uploadCompleteUrl, { 
      sizeInBytes: file.size, 
      path: fileInfo.path, 
      sessionId: this.sessionId, 
      sessionUser: this.sessionUserInfo,
      fileName: file.name
     }, 
      {
      headers: {
        'Content-Type': 'application/json',
        'TenantAlias':  environment.tenantAlias,
      },
    });
    return signedUrl;
  }
}

export default new FileUploadService();